import { api, type ReactQueryOptions, type RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { useSession } from '@shared/hooks/useSession'

type optionsType = ReactQueryOptions['StoreManager']['getItems']
type inputType = RouterInputs['StoreManager']['getItems']

/** Возвращает стор айтемы всех пользователей, исключая свои **/

export const useGetStoreItems = (input: inputType, options?: optionsType) => {
    const { status } = useSession()
    return api.StoreManager.getItems.useQuery(input, {
        ...options,
        queryKey: ['StoreManager.getItems', input],
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        // refetchOnMount: 'always',
        // cacheTime: 0,
        staleTime: 2 * 60 * 1000 * staleTimeIndex, // 2 mins
        enabled: status === 'authenticated' && options?.enabled,
    })
}
